module.exports = __webpack_public_path__ + "html/modal-overlay.template.html";